import { Controller } from "@hotwired/stimulus"

// Base animation class extended by other controllers
export default class extends Controller {
    static targets = ["animatedElement"]
    static values = {
        delay: { type: Number, default: 1500 },
        finalDelay: { type: Number, default: 500 }
    }

    connect() {
        // Reset any animations when controller connects
        this.resetAnimations()

        // Listen for step shown events
        window.addEventListener('onboarding:step-shown', this.handleStepShown.bind(this))
    }

    disconnect() {
        window.removeEventListener('onboarding:step-shown', this.handleStepShown.bind(this))
    }

    handleStepShown(event) {
        // Check if the shown step matches this controller's element
        const stepKey = this.element.closest('[data-step-key]')?.dataset.stepKey
        if (event.detail?.stepKey === stepKey) {
            this.animate()
        }
    }

    resetAnimations() {
        // Reset all animated elements to hidden
        if (this.hasAnimatedElementTarget) {
            this.animatedElementTargets.forEach(el => {
                el.classList.add("opacity-0")
                el.classList.remove("opacity-100")
            })
        }
    }

    animate() {
        // Reset animations first
        this.resetAnimations()

        // Start animations with a slight delay
        setTimeout(() => this.startSequence(), 100)
    }

    startSequence() {
        if (!this.hasAnimatedElementTarget) return

        let delay = 0
        const elements = this.animatedElementTargets

        elements.forEach((el, index) => {
            setTimeout(() => {
                // Show the element
                el.classList.remove("opacity-0")
                el.classList.add("opacity-100")

                // If this is the last element, notify that animations are complete
                if (index === elements.length - 1) {
                    setTimeout(() => {
                        this.notifyAnimationsComplete()
                    }, this.finalDelayValue)
                }
            }, delay)

            delay += this.delayValue
        })
    }

    notifyAnimationsComplete() {
        // Dispatch event to notify that animations are complete
        const event = new CustomEvent('onboarding:animations-complete', {
            bubbles: true
        })
        document.dispatchEvent(event)
    }
}
